/* eslint-disable no-shadow */
/* eslint-disable prefer-regex-literals */
/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable no-promise-executor-return */
/* eslint-disable no-undef */
/* eslint-disable prefer-arrow-functions/prefer-arrow-functions */
/* eslint-disable no-unused-vars */
/* eslint-disable guard-for-in */
/* eslint-disable no-console */
/* eslint-disable max-lines */
/* eslint-disable no-restricted-syntax */
// TODO: disable-eslint rules should be removed when the file is refactored
import 'isomorphic-fetch';

// const { Raven } = window;
import { appURL, clientId, clientSecret } from 'settings';
/**
 * Represents the standard shape of the fetch API Response object. Commonly used when not returing a directly parsed
 * response object (such as in the case with a failed request).
 *
 * @typedef {object} APIResponse
 * @property {ReadableStream | null} body - A stream of the body contents. Null if the body has already been read.
 * @property {boolean} bodyUsed - Indicates whether the body has been read.
 * @property {Headers} headers - The headers received in the response.
 * @property {boolean} ok - True if the status is in the range 200-299; false otherwise.
 * @property {number} status - The status code of the response (e.g., 200 for success, 404 for not found).
 * @property {string} statusText - The status message as a string (e.g., 'OK' for 200, 'Not Found' for 404). Note: Not
 *   always present in HTTP/2.
 * @property {string} type - The type of the response (e.g., 'basic', 'cors', 'default', 'error', or 'opaque').
 * @property {string} url - The URL of the response.
 */

let APIHandler;

// Set the client ID based on the hostname
let baseClientID = clientId;
let baseAppURL = appURL;
if (
  window.location.hostname === 'usadiscoveryprogram.co.nz' ||
  window.location.hostname === 'www.usadiscoveryprogram.co.nz'
) {
  // NZ
  baseClientID = 163;
  baseAppURL = 'https://www.usadiscoveryprogram.co.nz';
} else if (
  window.location.hostname === 'usadiscoveryprogram.com.au' ||
  window.location.hostname === 'www.usadiscoveryprogram.com.au'
) {
  // AU
  baseClientID = 164;
  baseAppURL = 'https://www.usadiscoveryprogram.com.au';
} else if (
  window.location.hostname === 'usadiscoveryprogram.co.uk' ||
  window.location.hostname === 'www.usadiscoveryprogram.co.uk'
) {
  // GB
  baseClientID = 165;
  baseAppURL = 'https://www.usadiscoveryprogram.co.uk';
} else if (
  window.location.hostname === 'usadiscoveryprogram.in' ||
  window.location.hostname === 'www.usadiscoveryprogram.in'
) {
  // IN
  baseClientID = 166;
  baseAppURL = 'https://www.usadiscoveryprogram.in';
} else if (
  window.location.hostname === 'usadiscoveryprogram.kr' ||
  window.location.hostname === 'www.usadiscoveryprogram.kr'
) {
  // KR
  baseClientID = 170;
  baseAppURL = 'https://www.usadiscoveryprogram.kr';
} else if (
  window.location.hostname === 'usadiscoveryprogram.mx' ||
  window.location.hostname === 'www.usadiscoveryprogram.mx'
) {
  // MX
  baseClientID = 168;
  baseAppURL = 'https://www.usadiscoveryprogram.mx';
} else if (
  window.location.hostname === 'usadiscoveryprogram.com.br' ||
  window.location.hostname === 'www.usadiscoveryprogram.com.br'
) {
  // BR
  baseClientID = 169;
  baseAppURL = 'https://www.usadiscoveryprogram.com.br';
} else if (
  window.location.hostname === 'usadiscoveryprogram.fr' ||
  window.location.hostname === 'www.usadiscoveryprogram.fr'
) {
  // FR
  baseClientID = 172;
  baseAppURL = 'https://www.usadiscoveryprogram.fr';
} else if (
  window.location.hostname === 'usadiscoveryprogram.de' ||
  window.location.hostname === 'www.usadiscoveryprogram.de'
) {
  // DE
  baseClientID = 173;
  baseAppURL = 'https://www.usadiscoveryprogram.de';
} else if (
  window.location.hostname === 'usadiscoveryprogram.it' ||
  window.location.hostname === 'www.usadiscoveryprogram.it'
) {
  // IT
  baseClientID = 171;
  baseAppURL = 'https://www.usadiscoveryprogram.it';
} else if (
  // CO
  window.location.hostname === 'usadiscoveryprogram.com.co' ||
  window.location.hostname === 'www.usadiscoveryprogram.com.co'
) {
  baseClientID = 177;
  baseAppURL = 'https://www.usadiscoveryprogram.co';
} else if (
  // CO
  window.location.hostname === 'usadiscoveryprogram.co' ||
  window.location.hostname === 'www.usadiscoveryprogram.co'
) {
  baseClientID = 177;
  baseAppURL = 'https://www.usadiscoveryprogram.co';
}

export default APIHandler = {
  makeRequest: (request, settings, customErrorHandler) =>
    fetch(request, settings)
      .then((response) => {
        if (response.ok) {
          return response
            .json()
            .then((json) => json)
            .catch(() => false);
        }
        return { ok: false, response };
      })
      .catch((err) => {
        if (customErrorHandler) {
          console.log(err);
          // customErrorHandler(err);
        } else {
          // Raven.captureException('API call failed', { extra: { requestURL: request, requestSettings: settings, err } });
        }
        return false;
      }),

  ok: (response) => {
    if (!response) {
      return false;
    }
    if (Object.keys(response).length > 0) {
      return true;
    }
    return false;
  },

  timeout: (ms, promise) =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error('timeout'));
      }, ms);
      promise.then(resolve, reject);
    }),

  getUserOld: (appId, email) => {
    const request = `https://accounts.travpromobile.com/api/v2/get_user/?email=${encodeURI(email)}&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  /**
   * Represents the standard shape of the user object.
   *
   * @typedef {object} User
   * @property {string} _id - The user's unique ID.
   * @property {string} email - The user's email address.
   * @property {string} type_of_user - The user's type.
   * @property {string} agency_name - The user's agency name.
   * @property {string} first_name - The user's first name.
   * @property {string} last_name - The user's last name.
   * @property {string} address - The user's address.
   * @property {string} address2 - The user's second address line.
   * @property {string} address3 - The user's third address line.
   * @property {string} city - The user's city.
   * @property {string} state - The user's state.
   * @property {string} country - The user's country.
   * @property {string} title - The user's title.
   * @property {string} zip_code - The user's zip code.
   * @property {string} phone - The user's phone number.
   * @property {string} mobile_phone - The user's mobile phone number.
   * @property {string} mobile_phone_number - The user's mobile phone number.
   * @property {string} id_type - The user's ID type.
   * @property {string} id_number - The user's ID number.
   * @property {string} sf_id - The user's Salesforce ID.
   * @property {string} agency_business - The user's agency business.
   * @property {string} agency_website - The user's agency website.
   * @property {string} agency_revenue - The user's agency revenue.
   * @property {string} agency_affiliation - The user's agency affiliation.
   * @property {string} host_agency - The user's host agency.
   * @property {string} host_agency_name - The user's host agency name.
   * @property {boolean} owner - Indicates whether the user is an owner.
   * @property {number} years_of_experience - The user's years of experience.
   * @property {string} annual_sales - The user's annual sales.
   * @property {string} destination_1 - The user's first destination.
   * @property {string} destination_2 - The user's second destination.
   * @property {string} destination_3 - The user's third destination.
   * @property {string} travel_type_1 - The user's first travel type.
   * @property {string} travel_type_2 - The user's second travel type.
   * @property {string} travel_type_3 - The user's third travel type.
   * @property {string} travel_type_4 - The user's fourth travel type.
   * @property {string} sales_companion_registered - The user's sales companion registration date.
   * @property {string} training_started - The user's training start date.
   * @property {string} training_graduated - The user's training graduation date.
   * @property {string} device - The user's device.
   * @property {string} registration_code - The user's registration code.
   * @property {string} fast_track - The user's fast track status.
   * @property {string} fast_track_date - The user's fast track date.
   * @property {string} fast_track_score - The user's fast track score.
   * @property {number} fast_track_duration - The user's fast track duration.
   * @property {string} custom_1 - The user's custom field 1.
   * @property {string} custom_2 - The user's custom field 2.
   * @property {string} custom_3 - The user's custom field 3.
   * @property {string} custom_4 - The user's custom field 4.
   * @property {string} custom_5 - The user's custom field 5.
   * @property {string} custom_6 - The user's custom field 6.
   * @property {string} custom_7 - The user's custom field 7.
   * @property {string} custom_8 - The user's custom field 8.
   * @property {string} custom_9 - The user's custom field 9.
   * @property {string} custom_10 - The user's custom field 10.
   * @property {boolean} marketing_opt_in - The user's marketing opt-in status.
   * @property {string} marketing_travel_brands - The user's marketing travel brands.
   * @property {boolean} owner_manager - Indicates whether the user is an owner/manager.
   */

  /**
   * @param {number} appId The application ID.
   * @param {string} accessToken The validation accesstoken.
   * @returns {User | APIResponse} This can either be the user object or a CORS response (in case of an error).
   */
  getUser: async (appId, accessToken) => {
    const request = `https://login.travpromobile.com/api/getUser/?app_id=${appId}`;

    const requestSettings = {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'GET',
      timeout: 5000,
    };

    const onError = (err) => {
      console.log('Error: ', err);
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      return err;
    };

    const res = await APIHandler.makeRequest(request, requestSettings, requestSettings, onError);

    if (res.response && res.response.status !== 200) {
      console.log(res.response);
      return res;
    }
    return res;
  },

  getUserRewards: async (email) => {
    const request = `https://accounts.travpromobile.com/api/v2/get_user/?email=${encodeURI(email)}`;
    return APIHandler.makeRequest(request);
  },

  checkPasswordUser: (email, password) => {
    const request = 'https://crm.travpromobile.com/api/authenticateMalibu';
    const data = {
      email,
      password,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then((res) => res);
  },

  setUser: (appId, params) => {
    // Format Date to dd-mm-yyyy, by adding a leading 0 and
    // slice last 2 characters to get Month and Day in two decimals.
    const date = new Date();
    const Month = `0${date.getMonth() + 1}`;
    const Day = `0${date.getDay()}`;
    const Year = date.getFullYear();
    const dateFormat = `${Year}-${Month.slice(-2)}-${Day.slice(-2)}`;

    let request = 'https://accounts.travpromobile.com/api/v2/user/?';
    request += `sales_companion_registered=${dateFormat}&`;
    request += `app_id=${appId}&`;
    request += 'type_of_user=pro';

    Object.keys(params).forEach((key) => {
      request += `&${key.replace(new RegExp('reg_', 'g'), '')}=${encodeURI(params[key])}`;
    });

    return APIHandler.makeRequest(request);
  },

  updateUser: (appId, email, params) => {
    const parameters = params.map((p, i) => `${i > 0 ? '&' : ''}${p.param}=${p.val}`).join('');
    const request = `https://accounts.travpromobile.com/api/v2/user/?email=${email}&${parameters}&app_id=${appId}`;
    return APIHandler.makeRequest(request, null, (err) => {
      // Raven.captureException('Updating user failed', { extra: { requestURL: request, requestSettings: null, err } });
    });
  },

  updateRegisterUser: (appId, email, params) => {
    let request = `https://accounts.travpromobile.com/api/v2/user/?email=${email}&app_id=${appId}`;
    for (let i = 0; i < Object.keys(params).length; i += 1) {
      const objectName = Object.keys(params)[i];
      request += `&${objectName}=${encodeURI(params[objectName])}`;
    }
    return APIHandler.makeRequest(request);
  },

  buildSearchIndex: (appId) => {
    let request = `https://stack.travpromobile.com/buildindex.php?app_id=${appId}`;
    if (appId > 500) {
      request = `https://stack.travpromobile.com/buildindex_v2.php?app_id=${appId}`;
    }
    return APIHandler.makeRequest(request);
  },

  updateSearchIndex: (appId) => {
    const request = `https://search.travpromobile.com/updateindex_v2.php?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getSearchResults: (appId, query) => {
    const request = `https://stack.travpromobile.com/query_v2.php?app_id=${appId}&q=${encodeURIComponent(query)}`;
    return APIHandler.makeRequest(request);
  },

  getBooths: (ids) => {
    let request = 'https://travproconnect.com/api/v1/companies-filtered/?countrySort=true';
    ids.forEach((id) => {
      request += `&ids[]=${id}`;
    });
    return APIHandler.makeRequest(request);
  },

  getStands: (ids, lang) => {
    const request = `https://travproconnect.com/api/v1/companies-filtered?lang=${lang}&${ids}`;
    return APIHandler.makeRequest(request);
  },

  // Semi-Redundant. the getChaptersAndProgress function returns the same information, including the chapter information,
  // and should be used instead. Leaving this function in place for now for backwards compatibility and legacy code.
  getUserProgress: (appId, email) => {
    let request = `https://progress.travpromobile.com/progress_user_v2/?email=${encodeURI(email)}`;
    if (['number', 'string'].includes(typeof appId)) {
      request += `&app_id=${appId}`;
    }
    if (appId?.isArray) {
      appId.forEach((id) => {
        request += `&app_id[]=${id}`;
      });
    }
    if (typeof appId === 'object') {
      appId.forEach((id) => {
        request += `&app_id[]=${id}`;
      });
    }
    return APIHandler.makeRequest(request);
  },

  getChaptersAndProgress: (appId, email, locale) => {
    const request = `https://progressv2.travpromobile.com/progress/app/${appId}/sections?email=${encodeURI(
      email,
    )}&locale=${locale}`;
    return APIHandler.makeRequest(request);
  },

  getSubappsNew: (appId, email, locale) => {
    const request = `https://progressv2.travpromobile.com/progress/app/${appId}/by_subapps?email=${encodeURI(
      email,
    )}&locale=${locale}`;
    return APIHandler.makeRequest(request);
  },

  registerUserProgress: (email) => {
    const request = 'https://progress.travpromobile.com/users/';
    const requestSettings = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: JSON.stringify({ user: { email } }),
    };

    const onError = (err) => {
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then((res) => {
      if (res.status !== 422) {
        return res;
      }
      return false;
    });
  },

  loginUser: async (username, password) => {
    const request = 'https://login.travpromobile.com/oauth/token';
    const data = {
      grant_type: 'password',
      client_id: baseClientID,
      client_secret: clientSecret,
      username,
      password,
    };
    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      timeout: 5000,
      body,
    };

    const onError = (err) => {
      console.log('Error: ', err);
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      return err;
    };

    const res = await APIHandler.makeRequest(request, requestSettings, onError);

    if (res.response && res.response.status !== 200) {
      return onError(await res.response.clone().json());
    }
    return res;

    // return APIHandler.makeRequest(request, requestSettings, onError)
    //   .then(({ response }) => {
    //     const { status } = response;
    //     if (status !== 200) {
    //       return respone
    //         .then((stream) => {
    //           const res = new Response(stream);
    //           console.log({ res });
    //           return res;
    //         });
    //     }
    //     return response;
    //   });
  },

  registerSSOUser: (name, email, company, password, passwordConfirmation) => {
    const request = 'https://login.travpromobile.com/api/register';

    const data = {
      client_id: baseClientID,
      client_secret: clientSecret,
      name,
      email,
      company,
      password,
      password_confirmation: passwordConfirmation,
    };

    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      timeout: 5000,
      body,
    };

    const onError = (err) => {
      console.log('error: ', err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then((res) => res);
  },

  forgotPassword: (email) => {
    const request = 'https://login.travpromobile.com/api/forgot_password';
    const data = {
      email,
      client_id: baseClientID,
    };

    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      timeout: 5000,
      body,
    };

    const onError = (err) => {
      console.log('error: ', err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then((res) => res);
  },

  resendVerificationLink(request) {
    const requestSettings = {
      method: 'GET',
      timeout: 5000,
    };

    const onError = (err) => {
      console.log('errorL ', err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then((res) => res);
  },

  getTravUser: (token) => {
    const request = 'https://progress.travpromobile.com/users/';
    const requestSettings = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: JSON.stringify({ user: { email } }),
    };

    const onError = (err) => {
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then((res) => {
      if (res.status !== 422) {
        return res;
      }
      return false;
    });
  },

  getFavoriteContent: (favorites, lang) => {
    const request = `https://cms.travpromobile.com/api/app/favorites/?lang=${lang}&`;
    let params = '';

    favorites.forEach((item) => {
      if (item.type === 'p') {
        params += `page[]=${item.unid}&`;
      } else {
        params += `page[]=${item.type}${item.unid}&`;
      }
    });

    return APIHandler.makeRequest(`${request}${params}`);
  },

  getFavorite: (appId, email) => {
    const request = `https://progress.travpromobile.com/favorites_by_app/${appId}/?email=${email}`;
    return APIHandler.makeRequest(request);
  },

  addFavorite: (params) => {
    const request = 'https://progress.travpromobile.com/favorites/';
    return APIHandler.makeRequest(request, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: JSON.stringify(params),
    });
  },

  removeFavorite: (params) => {
    const request = 'https://progress.travpromobile.com/favorites';

    return APIHandler.makeRequest(request, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
      timeout: 5000,
      body: JSON.stringify(params),
    });
  },

  setUserProgress: (params) => {
    const request = 'https://progressv2.travpromobile.com/progress';

    const requestObject = {
      chapter_id: +params.chapterId,
      lastpage: params.lastPage,
      progress: params.progress,
      email: params.email,
      user_agent: 'web',
      ip_address: '192.0.0.1',
      device: 'web',
    };

    const valid = Object.values(requestObject).every((param) => param);
    const NaNCheck = +requestObject.lastpage && +requestObject.progress;
    const positive = +requestObject.lastpage >= 0 && +requestObject.progress >= 0;

    if (valid && NaNCheck && positive) {
      return APIHandler.makeRequest(request, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        timeout: 5000,
        body: JSON.stringify(requestObject),
      });
    }
    return new Promise((resolve) => resolve(new Error('One of the supplied values was invalid.')));
  },

  getLocation: () => {
    const request = 'https://pro.ip-api.com/json?key=lsCvt9AP5YqiVgL';
    return APIHandler.makeRequest(request);
  },

  getExhibitionStands: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getExhibitionStandsCategory: (id) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?id=${id}&country=true`;
    return APIHandler.makeRequest(request);
  },

  getExhibitionStandsByCategory: (category, appId) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?category=${category}&app_id=${appId}&country=true`;
    return APIHandler.makeRequest(request);
  },

  getExhibitionStandsUnsorted: (id) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?id=${id}&country=true`;
    return APIHandler.makeRequest(request);
  },

  getProfile: (profileId) => {
    const request = `https://travproconnect.com/api/v2/profile/${profileId}?format=json&chat=true`;
    return APIHandler.makeRequest(request);
  },

  getPremiumHotelsList: (lat1, lat2, lon1, lon2) => {
    const request = `https://travproconnect.com/api/v1/companies_region/?&live=true&appcode=vegas&lat1=${lat1}&lat2=${lat2}&lon1=${lon1}&lon2=${lon2}&preview=true`;
    return APIHandler.makeRequest(request);
  },

  getFreeHotelsList: (lat1, lat2, lon1, lon2, query) => {
    const request = `https://travpro.yourworldapps.nl/API/app/v2/listings.php?app=1441&lat1=${lat1}&lat2=${lat2}&lon1=${lon1}&lon2=${lon2}&query=${query}`;
    return APIHandler.makeRequest(request);
  },

  getNamedCollection: (title, appId, lang) => {
    const request = `https://cms.travpromobile.com/api/app/named-collection?title=${title}&app_id=${appId}&region=true&lang=${lang}`;
    return APIHandler.makeRequest(request);
  },

  getMessage: (appId, lang) => {
    const request = `https://cms.travpromobile.com/api/app/message/?app_id=${appId}&format=json&lang=${lang}`;
    return APIHandler.makeRequest(request);
  },

  getAnnouncement: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/notification/true/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getUnreadMessages: (appId, lastChecked) => {
    const request = `https://cms.travpromobile.com/api/app/latest_message/?app_id=${appId}&date=${lastChecked}`;
    return APIHandler.makeRequest(request);
  },

  // Semi-Redundant. the getChaptersAndProgress function returns the same information, including the chapter progress,
  // and should be used instead. Leaving this function in place for now for backwards compatibility and legacy code.
  getChapters: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/chapter-info/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getFastFacts: (appId, country, lang) => {
    const request = `https://cms.travpromobile.com/api/app/sales-companion/?app_id=${appId}&type=fastfacts&format=json&country=test&lang=${lang
      .replace('pt_PT', 'pt_BR')
      .replace('ko_KO', 'ko_KR')
      .replace('kr_KR', 'ko_KR')}`;
    return APIHandler.makeRequest(request);
  },

  getToolbox: (appId, country, lang) => {
    const request = `https://cms.travpromobile.com/api/app/sales-companion/?app_id=${appId}&type=toolbox&format=json&country=test&lang=${lang
      .replace('pt_PT', 'pt_BR')
      .replace('ko_KO', 'ko_KR')
      .replace('kr_KR', 'ko_KR')}`;
    return APIHandler.makeRequest(request);
  },

  getTrainingPages: (chapterId, lang) => {
    // const { langFile, code } = lang;
    const request = `https://cms.travpromobile.com/api/app/chapter-content/?chapter_id=${chapterId}&format=json&lang=${lang
      .replace('es-ES', 'es-41')
      .replace('pt-PT', 'pt-BR')
      .replace('ko-KO', 'ko-KR')}`;
    return APIHandler.makeRequest(request);
  },

  getPages: (chapterId) => {
    const request = `https://cms.travpromobile.com/api/app/chapter-content/?chapter_id=${chapterId}&format=json&type=pages`;
    return APIHandler.makeRequest(request);
  },

  getDLC: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/getDLC/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getPrizeCenter(appId) {
    const request = `https://cms.travpromobile.com/api/app/prize-center?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getLeaderBoard(appId, email) {
    // Filter = false, means the prize center has no filters
    const request = `https://crm.travpromobile.com/api/rank-short?email=${email}&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getPoints(appId, startDate, endDate, accessToken) {
    const request = `https://rewardsbeta.travpromobile.com/api/rewards/user?app_id=${appId}&start_date=${startDate}&end_date=${endDate}`;
    const requestSettings = {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'GET',
      timeout: 5000,
    };
    return APIHandler.makeRequest(request, requestSettings);
  },

  getRewards(appId, accessToken, startDate = undefined, endDate = undefined) {
    const searchParams = {
      app_id: appId,
      start_date: startDate,
      end_date: endDate,
    };

    const filteredSearchParams = Object.fromEntries(
      Object.entries(searchParams).filter(([_, value]) => value !== undefined),
    );

    const parameters = new URLSearchParams(filteredSearchParams);

    const request = ['https://crm.travpromobile.com/api/rewards', parameters].join('?');
    const requestSettings = {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return APIHandler.makeRequest(request, requestSettings);
  },

  getDashboardItems: async (baseAppId, email, maxSharePoints, rewardsPoints, sharePoints, trainingPoints) => {
    const request = `https://crm.travpromobile.com/api/points-count?app_id=${baseAppId}&rewards_points=${rewardsPoints}&train_points=${trainingPoints}&email=${email}&max_share_points=${maxSharePoints}&share_points=${sharePoints}`;

    return APIHandler.makeRequest(request);
  },

  getVideos: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/carousel-video/?app_id=${appId}&type=both&autoPlay=true&format=json&app=new`;
    return APIHandler.makeRequest(request);
  },

  getImages: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/carousel-photo?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getCollection: (itemID) => {
    const request = `https://cms.travpromobile.com/api/app/collection?sales_companion_item_id=${itemID}`;
    return APIHandler.makeRequest(request);
  },

  getDownloadURL: (file, lang) => {
    const request = `https://stack.travpromobile.com/download.php?url=${file}&lang=${lang}`;
    return APIHandler.makeRequest(request);
  },

  getAppInfo: (appId, lang) => {
    const request = `https://cms.travpromobile.com/api/app/app-info/?app_id=${appId}&format=json&lang=${lang
      .replace('pt_pt', 'pt_br')
      .replace('ko_ko', 'ko_kr')}`;
    return APIHandler.makeRequest(request);
  },

  // TODO: Update with new API call when the next version of the endpoint is ready
  getSubApps: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/training?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  // getUserPoints: (appId, email, country) => {
  //   const request = `https://crm.travpromobile.com/api/points?email=${email}&app_id=${appId}&country=${country}`;
  //   return APIHandler.makeRequest(request);
  // },

  // New Points API (now contains badges)
  getUserPointsNew: (appId, email, lang) => {
    const request = `https://crm.travpromobile.com/api/points/badges?email=${email}&app_id=${appId}&lang=${lang}`;
    return APIHandler.makeRequest(request);
  },

  // TODO: Remove after removing all references to legacy version.
  setUserPoints(appId, { email, action, value }) {
    const request = `https://crm.travpromobile.com/api/point?email=${email}&action=${action}&action_value=${value}&app_id=${appId}`;
    return APIHandler.makeRequest(request, { method: 'POST' });
  },

  /**
   * @typedef {object} Update A key-value pair object that represents the update to be made.
   * @property {string} action The type of action to be performed (updated). Possible values are:
   *   'intro-chapter','specialization', and 'subapp'.
   * @property {string} action_value The value of the action to be performed (updated). These are unique identifying
   *   values for the associated training type. For 'intro-chapter' and 'specialization', this is the chapter ID. For
   *   'subapp', this is the sessionAppId ID.
   */

  /**
   * The new update user points API. This API allows for multiple updates to be made in a single request. (compared to
   * the old api)
   *
   * @param {number} appId The application ID
   * @param {string} email The user email
   * @param {Update | Update[]} updates An object or array of objects representing the updates to be made.
   * @returns {Promise<APIResponse>} The response from the API
   */
  setUserPointsNew(appId, email, updates) {
    const request = `https://crm.travpromobile.com/api/v2/point?email=${email}`;

    // Parsing to catch both conventional javascript casing (value) and the snake_case used by the API (action_value)
    const formattedUpdates = updates.map((update) => {
      const { action, action_value, value } = update;
      return {
        app_id: appId,
        action,
        action_value: action_value || value,
      };
    });

    // Backend expects an object with the { body : stringifiedUpdates } structure. Hence the stringifiedception.
    const stringifiedUpdates = JSON.stringify(formattedUpdates);

    const requestSettings = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ body: stringifiedUpdates }),
    };

    return APIHandler.makeRequest(request, requestSettings);
  },

  getContests: (appId, { currentDate, marketFilter = [] }) => {
    // const parameters = new URLSearchParams({ app_id: appId, current_date: currentDate });
    let date = new Date();
    [date] = date.toISOString().split('T');

    // TODO change app ID from pulling
    const parameters = new URLSearchParams({ app_id: 1469, current_date: date });
    marketFilter.forEach((param) => parameters.append('market_filter[]', JSON.stringify(param)));
    // marketFilter.forEach((param) => parameters.append('market_filter[]', JSON.stringify({ id: 'GB' })));

    const request = ['https://cms.travpromobile.com/api/contests', parameters].join('?');

    return APIHandler.makeRequest(request);
  },

  getIncentive: (id) => {
    const request = `https://cms.travpromobile.com/api/incentive/?id=${id}`;
    return APIHandler.makeRequest(request);
  },

  setChapterCompleted: (appId, email, chapterId, chapterNumber) => {
    const request = 'https://crm.travpromobile.com/api/chapter';
    const data = {
      app_id: appId,
      email,
      chapter_id: chapterId,
      chapter_number: chapterNumber,
    };

    const requestSettings = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    };

    const onError = (err) => {
      console.log(err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then((res) => res);
  },

  sendEmail: (type, appId, email, first_name, last_name) => {
    const request = 'https://crm.travpromobile.com/api/email';
    const data = {
      type,
      last_name,
      first_name,
      app_id: appId,
      email,
      domain: `https://${window.location.hostname}`,
    };

    const requestSettings = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    };

    const onError = (err) => {
      console.log(err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then((res) => res);
  },

  getContacts: (appId) => {
    const request = `https://cms.travpromobile.com/api/contact-us?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  trackSearch: (boothIds, email) => {
  const action = 'click';
  const request = `https://login.travpromobile.com/api/event?empty=${boothIds}`;
  const data = {
    app_id: 0,
    email,
    action: 'click',
    category: 'profile',
    name: 'search-result',
    value: 'search-result',
    unique: false,
  };

  const formData = new FormData();
  for (const item in data) {
    formData.append(item, data[item]);
  }

  const requestSettings = {
    method: 'POST',
    timeout: 5000,
    body: formData,
  };

  return APIHandler.makeRequest(request, requestSettings).then(() => false);
},

  trackEvent: (appId, email, category, name, value, label = null) => {
    const action = 'click';
    const request = 'https://crm.travpromobile.com/api/event';
    const data = {
      app_id: appId,
      email,
      action,
      category,
      name,
      value,
      label,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(() => false);
  },

  lastActive: (appId, email) => {
    const request = `https://crm.travpromobile.com/api/event?app_id=${appId}&email=${email}&action=open&category=last-active&name=app&value=session`;

    const requestSettings = {
      method: 'POST',
      timeout: 5000,
    };

    const onError = (err) => {
      console.log('error: ', err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then((res) => res);
  },

  checkEmail: async (email) => {
    const request = `https://login.travpromobile.com/api/user-exists`;

    const formData = new FormData();
    formData.append('email', email);
    formData.append('client_id', baseClientID);

    const requestSettings = {
      headers: {
        Accept: 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    const onError = (err) =>
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      err;
    const res = await APIHandler.makeRequest(request, requestSettings, requestSettings, onError);
    return res;
  },

  magicLink: async (email, language) => {
    const request = 'https://login.travpromobile.com/api/login/passwordless';

    const formData = new FormData();
    formData.append('email', email);
    formData.append('client_id', baseClientID);
    formData.append('url', baseAppURL);
    formData.append('language', language);

    const requestSettings = {
      headers: {
        Accept: 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    const onError = (err) =>
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      err;
    const res = await APIHandler.makeRequest(request, requestSettings, requestSettings, onError);
    return res;
  },

  loginMagicLink: async (token) => {
    const request = 'https://login.travpromobile.com/oauth/token';
    const data = {
      grant_type: 'passwordless',
      client_id: baseClientID,
      client_secret: clientSecret,
      token,
    };
    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      timeout: 5000,
      body,
    };

    const onError = (err) =>
      // alert("Currently it's very busy, please try again at a later moment. Thank you.");
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      err;
    const res = await APIHandler.makeRequest(request, requestSettings, onError);

    if (res.response && res.response.status !== 200) {
      return onError(await res.response.clone().json());
    }
    return res;
  },

  addReward: (reward) => {
    const request = 'https://crm.travpromobile.com/api/reward';

    const data = {
      app_id: reward.appId,
      booking_number: reward.booking_number,
      reservation_number: reward.reservation_number,
      arrival_date: reward.arrival_date,
      departure_date: reward.departure_date,
      length_of_stay: reward.length_of_stay,
      number_of_guests: reward.number_of_guests,
      agent_email: reward.agent_email,
      agent_last_name: reward.agent_last_name,
      agent_first_name: reward.agent_first_name,
      origin_airport: reward.origin_airport,
      ticket_number: reward.ticket_number,
      url: reward.files,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      headers: {
        Accept: 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then((response) => response);
  },

  uploadFile: (file, accessToken) => {
    const request = 'https://crm.travpromobile.com/api/file-upload';
    const formData = new FormData();
    formData.append('name', file.name);
    formData.append('size', file.size);
    formData.append('type', file.type);
    formData.append('file', file.url);

    const requestSettings = {
      method: 'POST',
      timeout: 5000,
      body: formData,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    };

    return APIHandler.makeRequest(request, requestSettings).then((response) => response);
  },
};
